<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title
        icon="ni ni-tv-2"
        main="Relatórios"
        sub="Meta Analítica do Cliente"
      ></page-title>

      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-12">
            <anosafra-multiselect
              v-model="filter.anosafra"
              label="Selecione o Ano Safra"
            />
          </div>
          <div class="col-md-4 col-sm-12">
            <label class="form-control-label">Vendedor *</label>
            <multiselect
              placeholder="Selecione o Vendedor"
              v-model="filter.salesman"
              :options="salesmen"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              label="name"
              track-by="id"
              :disabled="!currentUser.is_admin && !currentUser.is_manager"
              @input="findClients('')"
              @search-change="initSalesmen"
            />
          </div>
          <div class="col-md-4 col-sm-12">
            <label class="form-control-label">Cliente *</label>
            <multiselect
              placeholder="Selecione o Cliente"
              v-model="filter.client"
              :options="clients"
              label="razao_social"
              track-by="id"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              @search-change="findClients"
            />
          </div>
          <div class="col-md-6 col-sm-12">
            <base-input
              label="Nome do Produto"
              v-model="filter.name"
              placeholder="Nome do Produto"
            />
          </div>
          <div class="col-md-6 col-sm-12">
            <label class="form-control-label">Marca</label>
            <multiselect
              v-model="filter.brand"
              :options="brands"
              :loading="!brands.length"
              placeholder="Selecione a marca"
              :show-no-options="false"
              label="name"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              track-by="id"
            />
          </div>
          <div class="col-md-4 col-sm-12">
            <label class="form-control-label">Grupo</label>
            <multiselect
              v-model="filter.group"
              :options="groups"
              :loading="!groups.length"
              placeholder="Selecione o grupo"
              :show-no-options="false"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              label="descricao"
              track-by="id"
            />
          </div>
          <div class="col-md-4 col-sm-12">
            <label class="form-control-label">Subgrupo</label>
            <multiselect
              v-model="filter.subgroup"
              :options="subgroups"
              :loading="!subgroups.length"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              placeholder="Selecione o subgrupo"
              :show-no-options="false"
              label="descricao"
              track-by="id"
            />
          </div>
          <div class="col-md-4 col-sm-12">
            <label class="form-control-label">Coluna</label>
            <multiselect
              placeholder="Tipo de Coluna"
              :options="tableColumn"
              v-model="filter.tableColumn"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :multiple="true"
            />
          </div>
        </div>
        <div slot="footer" class="row justify-content-end mr-1">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button type="secondary" class="mr-2 mt-2" @click="generatePDF">Gerar PDF</base-button>
          <base-button type="secondary" class="mt-2"  @click="exportToExcel">Gerar Excel</base-button>
          <base-button
            type="primary"
            class="ml-2 mt-2"
            @click="generateReport"
            v-loading="isLoading"
            >Gerar Relatório</base-button
          >
        </div>
      </card>
    </div>

    <card ref="report" v-loading="isLoading">
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Histórico - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          v-if="filter.salesman && Object.keys(filter.salesman).length"
          class="text-uppercase text-muted ls-1 mb-1"
        >
          Cliente - {{ filter.client && filter.client.razao_social }}
        </h6>
      </div>

      <div class="col print-only">
        <img
          :src="
            setting_image && setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          class="navbar-brand-img"
          style="width: 200px; display: block; margin-left: auto; margin-right: auto;"
        />
        <h5 class="h1 mb-0">Relatório</h5>
        <h6 class="h3 text-uppercase text-muted ls-1 mb-1">
          Volume de Vendas - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.salesman && Object.keys(filter.salesman).length"
        >
          Vendedor: {{ filter.salesman.name }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.anosafra && Object.keys(filter.anosafra).length"
        >
          Ano Safra: {{ filter.anosafra.descricao }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.name">
          Nome do Produto: {{ filter.name }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.code">
          Código: {{ filter.code }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.brand">
          Marca: {{ filter.brand }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.group && Object.keys(filter.group).length"
        >
          Grupo: {{ filter.group.descricao }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.subgroup && Object.keys(filter.subgroup).length"
        >
          Subgrupo: {{ filter.subgroup.descricao }}
        </h6>
        <br />
        <br />
        <br />
      </div>
      <div
        class="group-block"
        v-for="(products, group, index) in grouped_products"
        :key="index"
      >
        <el-table
          class="table-responsive table-striped"
          min-width="500px"
          :header-row-class-name="rowClass"
          min-wid_typeth="500px"
          :data="products"
          show-summary
          :summary-method="getSummaries"
        >
         <el-table-column
            width="150"
            label="Nome"
            prop="description"
          />

          <el-table-column :label="group">
            <el-table-column
              v-if="filter.tableColumn.includes('Marca') || filter.tableColumn.includes('Todas')"
              min-width="150"
              label="Marca"
              prop="brand"
            />
            <el-table-column
              v-if="filter.tableColumn.includes('Vol. Realizado') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Vol. Realizado"
              prop="completed_volume"
            />
            <el-table-column
              v-if="filter.tableColumn.includes('Meta (R$)') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Meta (R$)"
              prop="currency_goal"
              prop-type="money"
              v-slot="{ row }"
            >
              {{
                row.currency_goal.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              }}
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('R$ Realizado') || filter.tableColumn.includes('Todas')"
              width="150"
              label="R$ Realizado"
              prop="currency_completed"
              prop-type="money"
              v-slot="{ row }"
            >
              {{
                row.currency_completed.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              }}
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Meta Realizado (%)') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Meta Realizado (%)"
              prop="goal_percent"
              prop-type="percentage"
              v-slot="{ row }"
            >
              {{ row.goal_percent > 120 ? 120 : row.goal_percent.toFixed(2) }} %
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Meta Financeiro (%)') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Meta Financeiro (%)"
              prop="goal_value_percent"
              prop-type="percentage"
              v-slot="{ row }"
            >
              {{
                row.goal_value_percent > 120
                  ? 120
                  : row.goal_value_percent.toFixed(2)
              }}
              %
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Quantidade do Pedido Em Carteira') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Quantidade do Pedido Em Carteira"
              prop="qtd_wallet"
            />
            <el-table-column
              v-if="filter.tableColumn.includes('Pedido em Carteira R$') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Pedido em Carteira R$"
              prop="currency_wallet"
              prop-type="money"
              v-slot="{ row }"
            >
              {{
                row.currency_wallet.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              }}
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Meta Realizada Total (%)') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Meta Realizada Total (%)"
              prop="total_percent"
              prop-type="percentage"
              v-slot="{ row }"
            >
              {{ row.total_percent > 120 ? 120 : row.total_percent.toFixed(2) }}
              %
            </el-table-column>
            <el-table-column
              v-if="filter.tableColumn.includes('Meta Realizada Total Financeiro (%)') || filter.tableColumn.includes('Todas')"
              width="150"
              label="Meta Realizada Total Financeiro (%)"
              prop="currency_total_percent"
              prop-type="percentage"
              v-slot="{ row }"
            >
              {{
                row.currency_total_percent > 120
                  ? 120
                  : row.currency_total_percent.toFixed(2)
              }}
              %
            </el-table-column>
          </el-table-column>
        </el-table>
        <br />
        <br />
      </div>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";


import { Table, TableColumn, DatePicker } from "element-ui";

export default {
  components: {
    PageTitle,
    Multiselect,
    AnosafraMultiselect,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
  },
  data() {
    return {
      active: true,
      clients: [],
      filter: {
        anosafra: "",
        //salesman: "",
        code: "",
        name: "",
        brand: "",
        group: null,
        subgroup: null,
        goalType: "",
        manager: {},
        salesman: {},
        tableColumn: []
      },
      goalTypes: [],
      brands: [],
      groups: [],
      subgroups: [],
      anosafras: [],
      salesmen: [],
      grouped_products: {},
      lastEdition: new Date(),
      salesman_validation: true,
      isLoading: false,
      isLoadingSalesman: false,
      tableColumn: ['Marca', 'KG/LT', 'Vol. Realizado', 'Meta (R$)', 'R$ Realizado', 'Meta Realizado (%)',
        'Meta Financeiro (%)', 'Quantidade do Pedido Em Carteira', 'Pedido em Carteira R$',
        'Pedido em Carteira R$', 'Meta Realizada Total (%)', 'Meta Realizada Total Financeiro (%)', 'Todas'
      ]
    };
  },
  methods: {
    initGoalTypes() {
      this.$http.secured.get("/api/v1/goals/types").then((response) => {
        this.goalTypes = response.data;
        this.goalTypes.splice(0, 1);
        this.goalTypes.splice(0, 1);
        if (this.currentUser.is_admin || this.currentUser.is_manager)
          this.goalTypes.push("Gerente Comercial");
      });
    },
    initManagers() {
      this.$http.secured
        .get("/api/v1/users", {
          params: {
            unpaged: true,
            q: { is_manager: true, anosafra_id: this.filter.anosafra.id, status: this.active },
          },
        })
        .then((response) => (this.managers = response.data));
    },
    userInfo(data) {
      var title = "";
      var name = "";

      if (data.manager && this.filter.goalType == "Gerente Comercial") {
        title = "GESTOR";
      } else if (this.filter.goalType != "vegetal") {
        title = "VENDEDOR";
      }

      if (data.user) name = data.user.name;

      return title ? `${title} - ${name}` : `${name}`;
    },

    filterSalesmen(manager) {
      this.filteredSalesmen = manager.salesmans;
    },
    findClients(query) {
      var data = {
        per_page: 10,
        q: {},
      };

      if (query.trim()) data.q.razao_social = query;
      if (this.filter.salesman && this.filter.salesman.id)
        data.q.user_ids = this.filter.salesman.id;
      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q.anosafra_ids = this.filter.anosafra.id;

      this.$http.secured
        .get("/api/v1/clients", { params: data })
        .then((response) => {
          this.clients = response.data.clients;
        })
        .catch(() => {
          // (this.$toasted.defaultError())
        });
    },
    generatePDF() {
      window.print();
    },
    exportToExcel() {
      return this.$exportToExcel();
    },
    rowClass({ row, rowIndex }) {
      if (rowIndex == 0) return "title-row";

      return "thead-light";
    },
    generateReport() {
      this.isLoading = true;

      if (!this.checkValidation()) {
        this.isLoading = false;
        this.$toasted.global.defaultError({msg: 'Favor preencher campos obrigatórios!'});
        return false;
      }

      this.$http.secured
        .get("/api/v1/report/analytical_clients", {
          params: {
            "filter[product_code]": this.filter.code ? this.filter.code : null,
            "filter[desc_psv]": this.filter.name ? this.filter.name : null,
            // "filter[codi_grp]": this.filter.group
            //   ? this.filter.group.erp_codes
            //   : null,
            "filter[marc_pro]": this.filter.brand
              ? this.filter.brand.name
              : null,
            "filter[codi_sbg]": this.filter.subgroup
              ? this.filter.subgroup.erp_code
              : null,
            //Usuario
            salesman_id: this.filter.salesman ? this.filter.salesman.id : null,
            analytical_client: true,
            client_id: this.filter.client ? this.filter.client.id : null,
            manager_id: this.filter.manager ? this.filter.manager.id : null,
            anosafra_id: this.filter.anosafra ? this.filter.anosafra.id : null,
            subgrupo_id: this.filter.subgroup ? this.filter.subgroup.id : null,
            grupo_id: this.filter.group ? this.filter.group.id : null,
            "products[code]": this.filter.code ? this.filter.code : null,
            name: this.filter.name ? this.filter.name : null,
            brand_id: this.filter.brand ? this.filter.brand.id : null,
          },
        })
        .then((response) => {
          this.lastEdition = new Date();
          this.grouped_products = response.data;
          this.isLoading = false;
        })
        .catch(() => (this.isLoading = false , console.log(error, "Something went wrong")));
    },
    initGroups() {
      this.$http.secured.get("/api/v1/grupos").then((response) => {
        this.groups = response.data;
      });
    },
    initSubgroups() {
      this.$http.secured.get("/api/v1/subgrupos").then((response) => {
        this.subgroups = response.data;
      });
    },
    initSalesmen(query) {
      var data = {
        name_only: true,
        q: { name: query, is_salesman: true, status: this.active }
      }

      if(this.currentUser.is_manager && !this.currentUser.is_admin) data.q['manager_id'] = this.currentUser.id
      if (this.filter.manager && this.filter.manager.coordinated_id) data.q["manager_id"] = this.filter.manager.coordinated_id;
      if(this.currentUser.is_admin && this.filter.manager) data.q['manager_id'] = this.filter.manager.id
      if(this.filter.anosafra && this.filter.anosafra.id) data.q['anosafra_id'] = this.filter.anosafra.id

      this.$http.secured
        .get("/api/v1/users", {params:data})
        .then((response) => {
          console.log(response)
          this.salesmen = response.data
        })
        .catch(() => {
          // this.$toasted.defaultError()
        });
    },
    loadSalesmen(query) {
      var data = {
        q: { name: query, is_salesman: true , status: this.active},
      };

      if (this.filter.manager && this.filter.manager.id)
        data.q["manager_id"] = this.filter.manager.id;
      if (this.filter.manager && this.filter.manager.coordinated_id)
        data.q["manager_id"] = this.filter.manager.coordinated_id;
      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q["anosafra_id"] = this.filter.anosafra.id;

      // if(this.currentUser.is_salesman && !this.currentUser.is_admin && !this.currentUser.is_manager) this.salesmen = [this.currentUser] || []
      // else {
      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.salesmen = response.data.users || [];
          this.filteredSalesmen = this.salesmen;
        })
        .catch((error) => {
          console.log(error, "Something went wrong")
        });
      // }
    },
    initData() {
      this.$http.secured
        .get("/api/v1/brands", { params: { name_only: true } })
        .then((response) => {
          this.brands = response.data;
        });
      // this.$http.secured
      //   .get("/api/v1/products", {})
      //   .then((response) => {
      //     response.data.products.map((product) =>
      //       this.codes.push(product.code)
      //     );
      //   })
      //   .catch((error) => {});
    },
    salesQuantity(product) {
      if (product.sales_quantity) return product.sales_quantity.toFixed(2);
    },
    checkValidation() {
      if (
        !this.filter.salesman ||
        typeof this.filter.salesman == "undefined" ||
        this.filter.salesman == ""
      ) {
        this.salesman_validation = false;
        return false;
      }

      this.salesman_validation = true;
      return true;
    },
    getSummaries(param) {
      var { columns, data } = param;
      var sums = [];

      // Calcs
      for (const index in columns) {
        if (index == 0) {
          sums[index] = "TOTAL";
          continue;
        }

        var values = data.map((item) => Number(item[columns[index].property]));

        if (values.every((value) => isNaN(value))) {
          sums[index] = " ";
          continue;
        }

        if (index == 7) {
          sums[index] = (100 * sums[6]) / sums[5];
          continue;
        }

        sums[index] = values.reduce(
          (prev, curr) => (Number(curr) || 0) + prev,
          0
        );
      }

      // Formating results
      for (const index in columns) {
        if (columns[index].label.indexOf("R$") >= 0) {
          sums[index] = sums[index].toLocaleString("pt-BR", {
            style: "currency",
            currency: "brl",
          });
          continue;
        }
        if (
          columns[index].label.indexOf("%") >= 0 &&
          columns[index].label.toUpperCase().indexOf("META") >= 0
        ) {
          if (sums[index] > 120) sums[index] = 120;
          sums[index] = sums[index].toFixed(2) + "%";
          continue;
        }

        sums[index] = " "; //sums[index].toFixed(2)
      }

      return sums;
    },
    clearFilters() {
      this.filter.salesman = {},
      this.filter.client = [],
      this.filter.name = "",
      this.filter.brand = "",
      this.filter.group = null,
      this.filter.subgroup = null,
      this.filter.tableColumn = []
    },
  },
  mounted() {
    this.initGoalTypes();
    this.currentUser = this.$currentUser();
    this.findClients("");
    this.filter.tableColumn.push(this.tableColumn[12]);
    if (this.currentUser.is_admin) {
      this.initManagers("");
    } else if (this.currentUser.is_manager) {
      this.filter.manager = this.currentUser;
    } else if (this.currentUser.is_salesman) {
      this.filter.salesman = this.currentUser;
      this.filter.manager = this.currentUser.manager;
    }

    if(this.$can('index', 'user')){
      this.loadSalesmen("");
    }

    this.initData();
    this.initGroups();
    this.initSubgroups();
  },
  computed: {
    setting_image() {
      return this.$store.state.imageSettings || {}
    }
  },
  watch: {
    "filter.anosafra": function () {
       if(this.$can('index', 'user')){
        this.loadSalesmen("");
      }
    },
    "filter.manager": function () {
       if(this.$can('index', 'user')){
        this.loadSalesmen("");
      }
    },
    "filter.goalType": function () {
      if (this.currentUser.is_admin) this.filter.manager = {};
      this.filter.salesman = {};
    },
  },
};
</script>
<style lang="scss">
@media print {
  table {
    div.cell {
      font-size: 30%;
    }
  }

  th {
    min-width: 50%;
    width: 50%;
    max-width: 50%;
  }
  td {
    min-width: 50%;
    width: 50%;
    max-width: 50%;
  }

  @page {
    size: landscape;
  }
}
.el-table__fixed,
.el-table__fixed-right {
  background-color: white;
  text-align: center;
}

.title-row {
  padding: 0;
  .cell {
    font-size: 150%;
    font-weight: bold;
  }
}
</style>
